var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"summary-title\" title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"indicators") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"indicators") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
    + "</div>\n    <div class=\"summary-performance\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"indicators") : depth0)) != null ? lookupProperty(stack1,"values") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":17,"column":17}}})) != null ? stack1 : "")
    + "    </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"col-xs-2 summary-label label-inline\">\n                "
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\n            </div>\n            <div class=\"col-xs-4 summary-value value-inline\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,(depth0 != null ? lookupProperty(depth0,"hint") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":14,"column":23}}})) != null ? stack1 : "")
    + "                "
    + alias1(__default(require("./numeral.js")).call(alias2,(depth0 != null ? lookupProperty(depth0,"value") : depth0),{"name":"numeral","hash":{},"data":data,"loc":{"start":{"line":15,"column":16},"end":{"line":15,"column":33}}}))
    + "\n            </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"btn btn-xs btn-tooltip\" data-toggle=\"tooltip\" data-placement=\"top\" title=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hint") : depth0), depth0))
    + "\"\n                         data-original-title=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"hint") : depth0), depth0))
    + "\">\n                        <i class=\"fa fa-info\"></i>\n                    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"indicators") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":19,"column":7}}})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/summary-indicators.hbs
// module id = belO
// module chunks = 1